import { useEffect, useState } from "react"

import { BOT_MESSAGE_DELAY, FIRST_NODE_ID } from "./config/config"
import { StoryNode } from "./config/story.types"

type Message = {
  id: string
  from: "bot" | "user"
  text: string
}

export function useChatbotEngine(story) {
  const [currentNodeId, setCurrentNodeId] = useState<string>(FIRST_NODE_ID)
  const [messages, setMessages] = useState<Message[]>([])
  const [canAnswer, setCanAnswer] = useState<boolean>(false)
  const [botMessageIndex, setBotMessageIndex] = useState(0)

  const node: StoryNode = story[currentNodeId]

  // Quand on change de noeud
  useEffect(() => {
    setCanAnswer(false)
    setBotMessageIndex(0)
  }, [currentNodeId])

  // Ajout progressif des messages du bot
  useEffect(() => {
    if (botMessageIndex >= node.botMessages.length) {
      setCanAnswer(true)
      return
    } else {
      setCanAnswer(false)
    }

    const timeout = setTimeout(() => {
      setMessages(prev => [
        ...prev,
        {
          id: `${currentNodeId}-${botMessageIndex}`,
          from: "bot",
          text: node.botMessages[botMessageIndex],
        },
      ])
    }, BOT_MESSAGE_DELAY)

    return () => clearTimeout(timeout)
  }, [botMessageIndex, node, currentNodeId])

  // Appelé quand un message a fini de s’écrire
  const onBotMessageDone = () => {
    setBotMessageIndex(i => i + 1)
  }

  const goToNode = (id: string) => {
    setCurrentNodeId(id)
  }

  return {
    messages,
    question: node.question,
    canAnswer,
    goToNode,
    onBotMessageDone,
  }
}
